export default __webpack_public_path__ + "static/media/netmaker-logo.b8edc1ae.png";